import React, {ComponentProps, ForwardedRef, forwardRef} from "react";
import {FormattedMessage} from "react-intl";

function CharLimit({value, charLimit}: {value: string; charLimit: number}) {
    const overLimit = value.length > charLimit;
    return (
        <div className="text-area-info">
            <span className="error-color">
                {overLimit && (
                    <FormattedMessage
                        id="message_maximum_characters"
                        values={{MAX_CHARS: charLimit}}
                    />
                )}{" "}
            </span>

            <span className={`${overLimit ? "error-color" : ""}`}>
                {value.length} / {charLimit}
            </span>
        </div>
    );
}

export const TextArea = forwardRef(function TextArea(
    {
        value,
        onChange,
        charLimit,
        ...props
    }: {
        value: string;
        onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
        charLimit?: number;
        props?: ComponentProps<"textarea">;
    },
    ref: ForwardedRef<HTMLTextAreaElement>
) {
    const overLimit = charLimit && value.length > charLimit;
    return (
        <>
            <textarea
                data-cy="add-comment-input"
                className={`message-input ${overLimit ? "input-error" : ""}`}
                ref={ref}
                value={value}
                onChange={onChange}
                rows={4}
                {...props}
            ></textarea>
            {charLimit && <CharLimit value={value} charLimit={charLimit} />}
        </>
    );
});
